import React from 'react'

interface Props {
    children: React.ReactNode,
    isOpen: boolean
}

const AppModalGeneral = ({ children, isOpen }: Props) => {
    return (
        <>
            {isOpen && (
                <>
                    <div className="fixed inset-0 z-50 flex items-center justify-center">
                    <div className="absolute inset-0 bg-black bg-opacity-40" />
                    {children}
                    </div>
                </>
            )}
        </>
    )
}

export default AppModalGeneral
